import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    itemsCount: (count: number) => string;
    pausedItemsCount: (count: number) => string;
    paused: string;
    cancelAll: string;
    resumeAll: string;
    pauseAll: string;
    separator: string;
    speedPerSecond: (speed: string) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status text showing count of items being transferred (e.g., "5 Items") */
            itemsCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "TotalProgressBar.itemsCount?c=12g8j6dzte074", defaultMessage: "{count, plural, one {1 Item} other {{count} Items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status text showing count of paused items (e.g., "5 Paused Items") */
            pausedItemsCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "TotalProgressBar.pausedItemsCount?c=akvoz8d45ip9", defaultMessage: "{count, plural, one {1 Paused Item} other {{count} Paused Items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when all transfers are paused */
            paused: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TotalProgressBar.paused?c=ylas17etod9r", defaultMessage: "Paused" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip and button label to cancel all transfers */
            cancelAll: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TotalProgressBar.cancelAll?c=gah1tystf2sr", defaultMessage: "Cancel all" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip and button label to resume all paused transfers */
            resumeAll: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TotalProgressBar.resumeAll?c=usu79sj5q87k", defaultMessage: "Resume all" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip and button label to pause all transfers */
            pauseAll: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TotalProgressBar.pauseAll?c=2dr0ckxgg0hj7", defaultMessage: "Pause all" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Separator between status items */
            separator: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TotalProgressBar.separator?c=38r9xp3x84a3b", defaultMessage: " \u00B7 " }));
                },
                enumerable: true,
                configurable: true
            },
            /** Transfer speed display (e.g., "1.2 Mb/s") */
            speedPerSecond: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (speed: string): string => __intl__.intl().formatMessage({ id: "TotalProgressBar.speedPerSecond?c=3hkjzv9jpstg0", defaultMessage: "{speed}/s" }, { speed: speed }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
